import { AlertDialog, AlertDialogContent, AlertDialogOverlay } from '@/components/ui/alert-dialog';
import { Button } from '@/components/ui/button';
import { CircleAlert } from 'lucide-react';
import { useTranslation } from 'react-i18next';

export default function AlertDialogDeleteSubsidiary({ open, onOpenChange, subsidiary, onConfirm, isSubmitting }) {
    const { t } = useTranslation();
    return (
        <AlertDialog open={open} onOpenChange={onOpenChange}>
            <AlertDialogOverlay />
            <AlertDialogContent className="bg-card rounded-2xl p-6 max-w-[400px] w-full border-0">
                <div className="flex flex-col items-center text-center">
                    <div className="w-14 h-14 bg-error/10 rounded-full flex items-center justify-center mb-4">
                        <CircleAlert className="h-7 w-7 text-error" />
                    </div>
                    <h3 className="text-[18px] text-foreground font-medium mb-2">{t('subsidiary:supprimerLeSousCompte')}</h3>
                    <p className="text-[14px] text-muted-foreground mb-6">
                        {t('subsidiary:cetteActionEstIrreversibleTousLesCollaborateursE')}
                    </p>
                    <div className="flex gap-3 w-full">
                        <Button
                            type="button"
                            variant="soft"
                            color="neutral"
                            onClick={() => onOpenChange(false)}
                            disabled={isSubmitting}
                            className="flex-1"
                        >
                            {t('subsidiary:annuler')}
                        </Button>
                        <Button
                            variant="solid"
                            color="destructive"
                            onClick={onConfirm}
                            disabled={isSubmitting}
                            className="flex-1"
                        >
                            {isSubmitting ? t('subsidiary:suppression') : t('subsidiary:supprimer')}
                        </Button>
                    </div>
                </div>
            </AlertDialogContent>
        </AlertDialog>
    );
}
